import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-unnecessary-condition */

import defaultConfig from '../../config/defaultConfig';
import { supportedMethodsByCurrency as supportedMethodsByCurrencyConfig } from '../../config/supportedMethodsByCurrency';
import { merge } from '@chegg/utils';
import { Processors } from '../../constants/AppConstants';
import { stripDebugOptionsIfProd } from '../../utils/DebugUtils';

/**
 * Returns merged configs of default and configs received from props
 * @param configs
 */
export var reconcileConfigs = function reconcileConfigs(configs) {
  var _paymentMethodsSuppor;
  // get list of payment methods that consumer wants to support
  var paymentMethods = configs.paymentMethods,
    priceSummary = configs.priceSummary;
  var paymentMethodsSupportedByCountry;
  // if price summary is defined at runtime, then we can go ahead and resolve the allowed
  // payment methods list.
  if (priceSummary) {
    var currency = priceSummary.currency;
    paymentMethodsSupportedByCountry = getSupportedPaymentMethods(currency, paymentMethods, supportedMethodsByCurrencyConfig);
  }
  stripDebugOptionsIfProd(configs);
  var mergedConfigs = merge(defaultConfig, _objectSpread(_objectSpread({}, configs), {}, {
    paymentProcessors: [Processors.BRAINTREE, Processors.BILLDESK, Processors.RECURLY],
    paymentMethods: paymentMethods,
    supportedPaymentMethods: (_paymentMethodsSuppor = paymentMethodsSupportedByCountry) !== null && _paymentMethodsSuppor !== void 0 ? _paymentMethodsSuppor : paymentMethods
  }));
  return mergedConfigs;
};

/**
 * @param requested list of methods requested by the consumer
 * @param supportedMethodsByCurrency supported processors by currency (see supportedMethodsByCurrencyConfig.json)
 * @param country user's current currency (passed in as a config)
 */
export var getSupportedPaymentMethods = function getSupportedPaymentMethods(currencyCode) {
  var requested = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultConfig.paymentMethods;
  var supportedMethodsByCurrency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : supportedMethodsByCurrencyConfig;
  var methodsForCurrency = getMethodsByCountry(currencyCode, supportedMethodsByCurrency);
  return requested.filter(function (method) {
    return methodsForCurrency.includes(method);
  });
};

/**
 * Returns the payment methods supported by braintree in the specified currency.
 * @param country
 * @param supportedMethodsByCurrency map of currencies to supported payment methods
 */
export var getMethodsByCountry = function getMethodsByCountry(currencyCode, supportedMethodsByCurrency) {
  var _supportedMethodsByCu;
  return (_supportedMethodsByCu = supportedMethodsByCurrency[currencyCode.toUpperCase()]) !== null && _supportedMethodsByCu !== void 0 ? _supportedMethodsByCu : supportedMethodsByCurrency['default'];
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/business/configManager/ConfigManager.js
// module id = 1473
// module chunks = 11